import { AppPalette } from '../../colors'

export const MuiCard = {
  styleOverrides: {
    root: {
      backgroundColor: `${AppPalette.NEUTRAL.light}`,
      border: `1px solid ${AppPalette.BORDER.light}`,
      boxShadow: 'none',
      padding: '16px'
    }
  }
}
